import type { AppAction } from './actions';
import type { RootState } from './index';
import { useDispatch as useReduxDispatch, useSelector as useReduxSelector } from 'react-redux';
import type { TypedUseSelectorHook } from 'react-redux';
import type { Dispatch } from 'redux';

export const useSelector: TypedUseSelectorHook<RootState> = useReduxSelector;
export const useDispatch = useReduxDispatch as () => Dispatch<AppAction>;
